export default "__VITE_ASSET__CwAK_mjk__"